import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';

import CreateModal from './modal';
import Dropdown from 'components/dropdown';
import ListingTypes from './listing_types';
import { Button } from 'components/ui/button';
import { buildNewDeal } from './helpers';

export default function DealCreationButton({
  condoListings,
  leaseSpaceListings,
  lotListings,
  path,
  saleListing,
  onNewDeal
}) {
  const [selectedListings, setSelectedListings] = useState();

  const allListings = useMemo(() => compact(flatten([condoListings, leaseSpaceListings, lotListings, saleListing])));
  const listingTypeCount = useMemo(() => uniq(allListings.map(listing => listing.type)).length);

  let button;
  if (listingTypeCount === 0) {
    button = (
      <Button
        className="disabled"
        disabled
        disabledTooltip='To create a deal, your listing must be marked as "For Sale" or "For Lease."'
        label="Create Deal"
      />
    );
  } else if (listingTypeCount === 1) {
    const handleClick = async () => {
      if (allListings.length === 1) {
        const listing = allListings[0];
        const deal = await buildNewDeal(path, listing);
        onNewDeal(deal, listing);
      } else {
        setSelectedListings(allListings);
      }
    };

    button = (
      <Button onClick={handleClick}>
        Create Deal
      </Button>
    );
  } else {
    const handleSelect = async (selection) => {
      if (selection.length === 1) {
        const listing = selection[0];
        const deal = await buildNewDeal(path, listing);
        onNewDeal(deal, listing);
      } else {
        setSelectedListings(selection);
      }
    };

    button = (
      <Dropdown label="Create Deal" variant="primary">
        <ListingTypes
          condoListings={condoListings}
          leaseSpaceListings={leaseSpaceListings}
          lotListings={lotListings}
          saleListing={saleListing}
          onListingsSelect={handleSelect}
        />
      </Dropdown>
    );
  }

  return <React.Fragment>
    {button}
    <CreateModal
      listings={selectedListings}
      path={path}
      show={selectedListings != null}
      onHide={() => setSelectedListings(null)}
      onNewDeal={onNewDeal}
    />
  </React.Fragment>;
}

DealCreationButton.propTypes = {
  condoListings: PropTypes.array,
  leaseSpaceListings: PropTypes.array,
  lotListings: PropTypes.array,
  path: PropTypes.string.isRequired,
  saleListing: PropTypes.object,
  onNewDeal: PropTypes.func.isRequired,
};
